import { createSlice } from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import {showNotification} from "./notification";

type State = {
    data: Array<Object>,
    isLoading: boolean,
    error: Object | null
}

const initialState = {
    data: [],
    isLoading: false,
    error: null,
}

const brands = createSlice({
    name: 'brands',
    initialState,
    reducers: {
        fetchBrandsStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchBrandsSuccess: (state: State, action) => {
            if (action.payload && Array.isArray(action.payload)) {
                state.data = action.payload.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });
            }
            state.isLoading = false;
            state.error = false;
        },
        fetchBrandsFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        }
    }
});

// Actions
export const {
    fetchBrandsStart,
    fetchBrandsSuccess,
    fetchBrandsFailed
} = brands.actions;

export default brands.reducer;

// Thunk
export const fetchBrands = () => async (dispatch: Function) => {
    try {
        dispatch(fetchBrandsStart());
        const api = new AdminApi();
        const result = await api.getBrands();
        dispatch(fetchBrandsSuccess(result));
    } catch (err: any) {
        dispatch(fetchBrandsFailed(err));
		dispatch(showNotification('error', err.message));
	}
}
